interface MenuIconProps {
  className?: string
  variant?: 'black' | 'white'
}

export default function MenuIcon({ className = '', variant = 'white' }: MenuIconProps) {
  return (
    <svg
      className={`h-6 w-6 ${className}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={variant === 'white' ? 'white' : 'black'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 6h16M4 12h16M4 18h16"
      ></path>
    </svg>
  )
}
